import { useContext } from 'react';
import { ClassifyContext } from "./context";
import { useIsomorphicLayoutEffect } from "./useIsomorphicEffect";
export var useClassify = function useClassify() {
  var context = useContext(ClassifyContext);
  if (!context) throw new Error('Can only usePushClassify inside ClassifyCollector');
  useIsomorphicLayoutEffect(function () {
    return context.onUpdate();
  });
  return context.createClass;
};